import {
  createContext,
  useContext,
  useState,
  useCallback,
  type ReactNode,
} from "react";
import { setToken, setRefreshToken, type UserSummary } from "../api/client.js";

interface AuthState {
  user: UserSummary | null;
  isAuthenticated: boolean;
  login: (token: string, refreshToken: string, user: UserSummary) => void;
  logout: () => void;
}

const AuthContext = createContext<AuthState | null>(null);

export function AuthProvider({ children }: { children: ReactNode }) {
  const [user, setUser] = useState<UserSummary | null>(null);

  const login = useCallback((token: string, refreshToken: string, user: UserSummary) => {
    setToken(token);
    setRefreshToken(refreshToken);
    setUser(user);
  }, []);

  const logout = useCallback(() => {
    setToken(null);
    setRefreshToken(null);
    setUser(null);
  }, []);

  return (
    <AuthContext.Provider
      value={{ user, isAuthenticated: !!user, login, logout }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth(): AuthState {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
}
